import { useUserInfo } from "@/api/user";
import { useAdminPanelNavigationItems } from "@/components/AdminPanel/AdminPanel";
import NotFoundPage from "@/pages/pages/404";
import { isPermittedSettingsDeepLink } from "@/utils/settingsNavigation";
import { useLocation } from "react-router-dom";

/** Placeholder route target for `/settings/*` deep links; dialog opens via LayoutSettingsShell. */
export function SettingsRouteSync() {
  const location = useLocation();
  const { isLoading: isUserInfoLoading } = useUserInfo();
  const { allMenuItems } = useAdminPanelNavigationItems();

  if (isUserInfoLoading) {
    return null;
  }

  if (!isPermittedSettingsDeepLink(location.pathname, allMenuItems)) {
    return <NotFoundPage />;
  }

  return null;
}
